import { License } from "../../shared/Enums/Licensing/License";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";


export enum Role {
    AdministrateurPST = "AdministrateurPST",
    UtilisateurPST = "UtilisateurPST",
    Administrateur = "Administrateur",
    Payeur = "Payeur"
}

export enum Categorie {
    Favoris = "Favoris",
    Personnel = "Personnel",
    Traitement = "Traitement",
    Editions = "Éditions",
    Outils = "Outils",
    Parametrage = "Paramétrage",
    Administration = "Administration"
}

export enum TypeCondition {
	isSalarie = "isSalarie",
	isModeConge = "isModeConge",
	isVisible = "isVisible",
	hasRole = "hasRole",
	paieNotEnable = "paieNotEnable",
	paieEnable = "paieEnable",
	modePst = "modePst",
	possedeReglementSepa = "possedeReglementSepa",
	hasLicense = "hasLicense",
	doNotHaveLicense = "doNotHaveLicense",
	hasFeatureFlag = "hasFeatureFlag",
}

export enum TypeAction {
	openTab = "openTab",
	openModal = "openModal",
	openmodalCloturePaie = "openmodalCloturePaie",
	openmodalDevalidationClotureExercice = "openmodalDevalidationClotureExercice",
	editionFinDeMois = "editionFinDeMois",
	openmodalVirementSepa = "openmodalVirementSepa",
	editionFinDeMoisCumulees = "editionFinDeMoisCumulees",
	envoyeBulletins = "envoyeBulletins",
	reeditionBulletins = "reeditionBulletins",
	openModalImporterTopaze = "openModalImporterTopaze",
	openUrl = "openUrl",
}

export enum Color {
	default = "black",
	royalRoyalLuxePrivilege = "#F6A92D",
}

export interface MenuChild {
	id: string;
	icone?: string;
	name: string;
	nameColor: string;
	path: string;
	authorizedRoles: Role[];
	authorizedLicense?: License;
	authorizedFeatureFlag?: FeatureFlagModuleEnum;
	isCombinedRoles?: boolean,
	typeAction: TypeAction;
	typeCondition: TypeCondition[];
	enableFav: boolean;
	dataCy: string;
	dataTestId: string;
}

export interface CategorieHead {
    id: string;
    name: Categorie;
    icon: string;
    dataCy: string;
	dataTestId: string;
    typeCondition: TypeCondition[];
    authorizedRoles: Role[];
}

export interface CategorieItem {
    head: CategorieHead;
    child: MenuChild[];
}

export interface MenuModel {
    categories: CategorieItem[];
}

// --------------------------------------------------------------------------
// --------------------------------------------------------------------------
// --------------------------------------------------------------------------

export const menuModel: MenuModel = {
	categories: [{
		head: {
			id: "SA",
			name: Categorie.Personnel,
			icon: "fa-users",
			dataCy: "cy-menu-tab-sa",
			dataTestId: "menu-personnel",
			authorizedRoles: [],
			typeCondition: []
		},
		child: [
			{
				id: "listesalaries",
				name: "Salariés",
				nameColor: Color.default,
				path: "/listesalaries",
				authorizedRoles: [Role.AdministrateurPST, Role.UtilisateurPST, Role.Administrateur, Role.Payeur],
				enableFav: true,
				typeAction: TypeAction.openTab,
				typeCondition: [TypeCondition.hasRole],
				dataCy: "cy-menu-tab-sa-listeSalaries",
				dataTestId: "menu-personnel-salaries"
			}, {
				id: "ficheSalarie",
				name: "Nouveau",
				nameColor: Color.default,
				path: "/ficheSalarie/0?titre=Nouveau salarié",
				authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
				enableFav: true,
				typeAction: TypeAction.openTab,
				typeCondition: [TypeCondition.hasRole],
				dataCy: "cy-menu-tab-sa-ficheSalarie",
				dataTestId: "menu-personnel-nouveau"
			}, {
				id: "listeEntreesSalarie",
				name: "Demandes d'entrées salariés",
				nameColor: Color.default,
				path: "/listeEntreesSalarie",
				authorizedRoles: [],
				enableFav: true,
				typeAction: TypeAction.openTab,
				typeCondition: [TypeCondition.isVisible],
				dataCy: "cy-menu-tab-sa-listeEntreeSalarie",
				dataTestId: "menu-personnel-entrees"
			}, {
				id: "listeSortiesSalarie",
				name: "Demandes de sorties salariés",
				nameColor: Color.default,
				path: "/listeSortiesSalarie",
				authorizedRoles: [],
				enableFav: true,
				typeAction: TypeAction.openTab,
				typeCondition: [TypeCondition.isVisible],
				dataCy: "cy-menu-tab-sa-listeSortiesSalarie",
				dataTestId: "menu-personnel-sorties"
			}, {
				id: "notaires",
				name: "Utilisateurs non salariés",
				nameColor: Color.default,
				path: "/utilisateursnonsalaries",
				authorizedRoles: [Role.AdministrateurPST, Role.UtilisateurPST, Role.Administrateur, Role.Payeur],
				enableFav: true,
				typeAction: TypeAction.openTab,
				typeCondition: [TypeCondition.hasRole],
				dataCy: "cy-menu-tab-sa-notaires",
				dataTestId: "menu-personnel-nonSalaries"
			}, {
				id: "dpae",
				name: "Demandes DPAE",
				nameColor: Color.default,
				path: "/dpae",
				authorizedRoles: [Role.Payeur, Role.Administrateur, Role.AdministrateurPST],
				enableFav: true,
				typeAction: TypeAction.openTab,
				typeCondition: [TypeCondition.hasRole],
				dataCy: "cy-menu-tab-sa-dpae",
				dataTestId: "menu-personnel-dpae"
			}, {
				id: "exercices",
				name: "Exercices",
				nameColor: Color.default,
				path: "/exercices",
				authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
				enableFav: true,
				typeAction: TypeAction.openTab,
				typeCondition: [TypeCondition.paieNotEnable, TypeCondition.hasRole],
				dataCy: "cy-menu-tab-sa-exercices",
				dataTestId: "menu-personnel-exercices"
			}, {
				id: "cloturermois",
				name: "Clôturer le mois",
				nameColor: Color.default,
				path: "",
				authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
				enableFav: true,
				typeAction: TypeAction.openmodalCloturePaie,
				typeCondition: [TypeCondition.paieNotEnable, TypeCondition.hasRole],
				dataCy: "cy-menu-tab-sa-cloturerMois",
				dataTestId: "menu-personnel-clotureMois"
			}, {
				id: "devalidermois",
				name: "Dévalider le mois clôturé",
				nameColor: Color.default,
				path: "",
				authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
				enableFav: true,
				typeAction: TypeAction.openmodalDevalidationClotureExercice,
				typeCondition: [TypeCondition.paieNotEnable, TypeCondition.hasRole],
				dataCy: "cy-menu-tab-sa-devaliderMois ",
				dataTestId: "menu-personnel-devaliderMois"
			}, {
				id: "mesabsences",
				name: "Mes absences",
				nameColor: Color.default,
				path: "/gestionDesAbsences",
				authorizedRoles: [],
				typeCondition: [TypeCondition.paieNotEnable, TypeCondition.isSalarie],
				enableFav: true,
				typeAction: TypeAction.openTab,
				dataCy: "cy-menu-tab-sa-mesabsences",
				dataTestId: "menu-personnel-mesAbsences"
			}
		]
	}, {
		head: {
			id: "TR",
			name: Categorie.Traitement,
			icon: "fa-tasks",
			dataCy: "cy-menu-tab-traitement",
			dataTestId: "menu-traitement",
			authorizedRoles: [],
			typeCondition: [TypeCondition.paieEnable]
		},
		child: [{
			id: "gestionDesAbsences",
			name: "Mes absences",
			nameColor: Color.default,
			path: "/gestionDesAbsences",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isSalarie, TypeCondition.isModeConge],
			dataCy: "cy-menu-tab-traitement-gestionAbsences",
			dataTestId: "menu-traitement-mesAbsences"
		}, {
			id: "planningAbsences",
			name: "Planning des absences",
			nameColor: Color.default,
			path: "/planningAbsences",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-traitement-planningAbsences",
			dataTestId: "menu-traitement-planningAbsences"
		}, {
			id: "saisieDesVariables",
			name: "Saisie des variables",
			nameColor: Color.default,
			path: "/saisieDesVariables",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-traitement-saisieVariables",
			dataTestId: "menu-traitement-saisieVariables"
		}, {
			id: "historiqueVariables",
			name: "Historique des variables",
			nameColor: Color.default,
			path: "/historiqueVariables",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible, TypeCondition.modePst],
			dataCy: "cy-menu-tab-traitement-historiqueVariable",
			dataTestId: "menu-traitement-historiqueVariables"
		}, {
			id: "calculPaie",
			name: "Calculs et bulletins",
			nameColor: Color.default,
			path: "/calculPaie",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-link-calcul-bulletin",
			dataTestId: "menu-traitement-calculPaie"
		}, {
			id: "editionsDeFinDeMois",
			name: "Éditions de fin de mois",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
			enableFav: true,
			typeAction: TypeAction.editionFinDeMois,
			typeCondition: [TypeCondition.paieEnable, TypeCondition.hasRole],
			dataCy: "cy-menu-tab-traitement-editionFinDeMois",
			dataTestId: "menu-traitement-editionsFinDeMois"
		}, {
			id: "cloturePaie",
			name: "Clôture de paie",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
			enableFav: true,
			typeAction: TypeAction.openmodalCloturePaie,
			typeCondition: [TypeCondition.paieEnable, TypeCondition.hasRole],
			dataCy: "cy-menu-tab-traitement-cloturePaie",
			dataTestId: "menu-traitement-cloturePaie"
		}, {
			id: "virementsepa",
			name: "Virements Sepa",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
			enableFav: true,
			typeAction: TypeAction.openmodalVirementSepa,
			typeCondition: [TypeCondition.possedeReglementSepa, TypeCondition.paieEnable, TypeCondition.hasRole],
			dataCy: "cy-menu-tab-traitement-virementSepa",
			dataTestId: "menu-traitement-virementsepa"
		}, {
			id: "devalideClotureExercice",
			name: "Dévalider le mois clôturé",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
			enableFav: true,
			typeAction: TypeAction.openmodalDevalidationClotureExercice,
			typeCondition: [TypeCondition.paieEnable, TypeCondition.hasRole],
			dataCy: "cy-menu-tab-traitement-devaliderClotureExercise",
			dataTestId: "menu-traitement-devaliderClotureExercice"
		}, {
			id: "envoiBulletins",
			name: "Envoi sécurisé des bulletins",
			nameColor: Color.default,
			path: "/envoiBulletins",
			authorizedRoles: [Role.AdministrateurPST, Role.UtilisateurPST, Role.Administrateur, Role.Payeur],
			authorizedLicense: License.Primobox,
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.hasLicense, TypeCondition.hasRole],
			dataCy: "cy-menu-tab-traitement-envoiBulletins",
			dataTestId: "menu-traitement-envoiBulletins"
		}, {
			id: "envoiBulletinsFlyer",
			icone: require("!svg-inline-loader!../../assets/vip_crown_fill.svg"),
			name: "Envoi sécurisé des bulletins",
			nameColor: Color.royalRoyalLuxePrivilege,
			path: "https://page.septeo.com/myprimobox",
			authorizedRoles: [Role.AdministrateurPST, Role.UtilisateurPST, Role.Administrateur, Role.Payeur],
			authorizedLicense: License.Primobox,
			enableFav: false,
			typeAction: TypeAction.openUrl,
			typeCondition: [TypeCondition.doNotHaveLicense, TypeCondition.hasRole],
			dataCy: "cy-menu-tab-traitement-envoiBulletinsFlyer",
			dataTestId: "menu-traitement-envoiBulletinsFlyer"
		}, {
			id: "dsn",
			name: "DSN",
			nameColor: Color.default,
			path: "/dsn",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-traitement-dsn",
			dataTestId: "menu-traitement-dsn"
		}]
	}, {
		head: {
			id: "ED",
			name: Categorie.Editions,
			icon: "fa-print",
			dataCy: "cy-menu-tab-ed",
			dataTestId: "menu-editions",
			authorizedRoles: [],
			typeCondition: [TypeCondition.paieEnable]
		},
		child: [{
			id: "tableaux",
			name: "Tableaux",
			nameColor: Color.default,
			path: "/tableaux",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-ed-tableaux",
			dataTestId: "menu-editions-tableaux"
		}, {
			id: "tableauxJournal",
			name: "Journal",
			nameColor: Color.default,
			path: "/tableaux?mode=journal",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-ed-tableauxJournal",
			dataTestId: "menu-editions-journal"
		}, {
			id: "editionFinDeMoisCumulees",
			name: "Éditions cumulées",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [Role.Administrateur, Role.AdministrateurPST, Role.Payeur],
			enableFav: true,
			typeAction: TypeAction.editionFinDeMoisCumulees,
			typeCondition: [TypeCondition.hasRole],
			dataCy: "cy-menu-tab-ed-editionFinMoisCumulees",
			dataTestId: "menu-editions-editionsCumulees"
		}, {
			id: "tableauxVariables",
			name: "Edition des variables",
			nameColor: Color.default,
			path: "/tableaux?mode=variables",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-ed-tableauxVariables",
			dataTestId: "menu-editions-variables"
		}, {
			id: "envoisParMail",
			name: "Envoyer bulletins par mail",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [Role.AdministrateurPST, Role.UtilisateurPST, Role.Administrateur, Role.Payeur],
			enableFav: true,
			typeAction: TypeAction.envoyeBulletins,
			typeCondition: [TypeCondition.hasRole],
			dataCy: "cy-menu-tab-ed-envoisParMail",
			dataTestId: "menu-editions-envoiMail"
		}, {
			id: "documents",
			name: "Documents",
			nameColor: Color.default,
			path: "/documents",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-ed-documents",
			dataTestId: "menu-editions-documents"
		}, {
			id: "reeditionBulletins",
			name: "Rééditions bulletins",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.reeditionBulletins,
			typeCondition: [],
			dataCy: "cy-menu-tab-ed-reeditionBulletins",
			dataTestId: "menu-editions-reeditionBulletins"
		}]
	}, {
		head: {
			id: "OU",
			name: Categorie.Outils,
			icon: "fa-tools",
			dataCy: "cy-menu-tab-ou",
			dataTestId: "menu-outils",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
			typeCondition: [TypeCondition.paieEnable, TypeCondition.hasRole]
		},
		child: [{
			id: "requeteur",
			name: "Requêteur",
			nameColor: Color.default,
			path: "/requeteur",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [],
			dataCy: "cy-menu-tab-ou-requeteur",
			dataTestId: "menu-outils-requeteur"
		}, {
			id: "modalImporterTopaze",
			name: "Import taux PAS",
			nameColor: Color.default,
			path: "",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
			enableFav: false,
			typeAction: TypeAction.openModalImporterTopaze,
			typeCondition: [TypeCondition.hasRole],
			dataCy: "cy-menu-tab-ou-modalImporterTopaze",
			dataTestId: "menu-outils-modalImporterTopaze"
		}]
	}, {
		head: {
			id: "PA",
			name: Categorie.Parametrage,
			icon: "fa-sliders-h",
			dataCy: "cy-menu-tab-pa",
			dataTestId: "menu-parametrage",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur, Role.Payeur],
			typeCondition: [TypeCondition.paieEnable, TypeCondition.hasRole]
		},
		child: [{
			id: "parametrespecifique",
			name: "Paramètres spécifiques",
			nameColor: Color.default,
			path: "/parametresSpecifiques",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-parametreSpecifique",
			dataTestId: "menu-parametrage-specifique"
		}, {
			id: "exercicespa",
			name: "Exercices",
			nameColor: Color.default,
			path: "/exercices",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-exercicePa",
			dataTestId: "menu-parametrage-exercices"
		}, {
			id: "rubriques",
			name: "Rubriques",
			nameColor: Color.default,
			path: "/listeRubriques",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-rubrique",
			dataTestId: "menu-parametrage-rubriques"
		}, {
			id: "scenarios",
			name: "Scénarios",
			nameColor: Color.default,
			path: "/scenarios",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-scenarios",
			dataTestId: "menu-parametrage-scenarios"
		}, {
			id: "libelles",
			name: "Libellés",
			nameColor: Color.default,
			path: "/libelles",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-libelles",
			dataTestId: "menu-parametrage-libelles"
		}, {
			id: "societe",
			name: "Société",
			nameColor: Color.default,
			path: "/societe",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-societe",
			dataTestId: "menu-parametrage-societe"
		}, {
			id: "listesocietes",
			name: "Liste sociétés",
			nameColor: Color.default,
			path: "/listeSocietes",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-listeSocietes",
			dataTestId: "menu-parametrage-listeSocietes"
		}, {
			id: "joursnontravailles",
			name: "Jours non travaillés",
			nameColor: Color.default,
			path: "/joursNonTravailles",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-joursNontravailles",
			dataTestId: "menu-parametrage-joursNontravailles"
		}, {
			id: "contrattype",
			name: "Contrat type",
			nameColor: Color.default,
			path: "/contratType",
			authorizedRoles: [],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.isVisible],
			dataCy: "cy-menu-tab-pa-contratType",
			dataTestId: "menu-parametrage-contratType"
		}, {
			id: "parametresmodule",
			name: "Paramètres de module",
			nameColor: Color.default,
			path: "/parametrageModule",
			authorizedRoles: [Role.Administrateur],
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.hasRole],
			dataCy: "cy-menu-tab-pa-parametreModule",
			dataTestId: "menu-parametrage-module"
		}, {
			id: "listetransfertsql",
			name: "Liste de transfert SQL",
			nameColor: Color.default,
			path: "/listeTransfertSql",
			authorizedRoles: [Role.Administrateur, Role.AdministrateurPST],
			isCombinedRoles: true,
			authorizedFeatureFlag: FeatureFlagModuleEnum.TransfertSql,
			enableFav: false,
			typeAction: TypeAction.openTab,
			typeCondition: [TypeCondition.hasRole, TypeCondition.hasFeatureFlag],
			dataCy: "cy-menu-tab-pa-listetransfertsql",
			dataTestId: "menu-listetransfertsql-module"
		}]
	}, {
		head: {
			id: "AD",
			name: Categorie.Administration,
			icon: "fa-cog",
			dataCy: "cy-menu-tab-ad",
			dataTestId: "menu-administration",
			authorizedRoles: [Role.AdministrateurPST, Role.Administrateur],
			typeCondition: [TypeCondition.hasRole]

		},
		child: [{
			id: "healthCheck",
			name: "Statuts",
			nameColor: Color.default,
			path: "/healthCheck",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [],
			dataCy: "cy-menu-tab-ad-healthCheck",
			dataTestId: "menu-administration-statuts"
		}, {
			id: "utilisateurs",
			name: "Utilisateurs",
			nameColor: Color.default,
			path: "/utilisateurs",
			authorizedRoles: [],
			enableFav: true,
			typeAction: TypeAction.openTab,
			typeCondition: [],
			dataCy: "cy-menu-tab-ad-utilisateurs",
			dataTestId: "menu-administration-utilisateurs"
        }]
    }]
};




// WEBPACK FOOTER //
// ./src/components/menu/menu.model.ts